import React from 'react';
import { Button } from '@mui/material';
import { useAuth } from '../../contexts/AuthContext';

const LogoutButton = ({ onClick, ...props }) => {
  const { logout } = useAuth();

  const handleClick = (e) => {
    onClick?.(e);
    logout();
  };

  return (
    <Button 
      variant="outlined" 
      color="secondary" 
      onClick={handleClick}
      {...props}
    >
      Log Out
    </Button>
  );
};

export default LogoutButton;
